import { ref, reactive, toValue } from "vue";
import { defu } from "defu";
import { defaultOptions } from "../../utils/defaultOptions.mjs";
const marqueeStateStore = ref([]);
export function useMarqueeState(instanceId) {
  function createState(id) {
    const state = {
      id,
      options: { ...defaultOptions },
      playing: true
    };
    return reactive(state);
  }
  function addState(id) {
    const state = createState(id);
    marqueeStateStore.value = [...marqueeStateStore.value, state];
    return state;
  }
  function initializeState(options) {
    let state = marqueeStateStore.value.find((entry) => {
      return entry.id === toValue(instanceId);
    });
    if (!state) {
      state = addState(toValue(instanceId));
    }
    if (options) {
      const mappedOptions = defu(options, defaultOptions);
      state.options = mappedOptions;
    }
    return state;
  }
  function deleteState() {
    marqueeStateStore.value = marqueeStateStore.value.filter(
      (x) => x.id !== toValue(instanceId)
    );
  }
  return {
    initializeState,
    deleteState,
    marqueeStateStore
  };
}
